import { SET_PARTNER_SMS_CONFIG } from "../redux/Action/partnerSmsConfigAction";
import { getValidAccessToken } from "../services/oauthservice";

export const generateOrderId = () => {
    const prefix = 'DIC';
    const randomNum = Math.floor(Math.random() * 10000000);
    return `${prefix}${randomNum}`;
  };

export const isArabic = (text) => {
  const arabicRegex = /[\u0600-\u06FF]/;
  return arabicRegex.test(text);
};

export const fetchPartnerSmsConfig = async (partnerId, dispatch) => {
  try {
    if (!partnerId) {
      console.warn('Skipping SMS config fetch: partnerId is missing.');
      return;
    }

    const token = await getValidAccessToken();
    const baseUrl = process.env.REACT_APP_DIC_ADMIN_API;

    const response = await fetch(
      `${baseUrl}/get/partner/smsConfig?PARTNER_ID=${partnerId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = await response.json();

    if (data?.data?.length) {
      dispatch({
        type: SET_PARTNER_SMS_CONFIG,
        payload: data.data[0],
      });
    } else {
      console.warn('No SMS config found for partner.');
    }
  } catch (error) {
    console.error('Error fetching partner SMS config:', error);
  }
};